import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const AdminStatsRow = ({ realUsers, pendingInvites, activeTrialUsers, subscribedUsers, expandedSection, setExpandedSection }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
    <Card className="bg-slate-800 border-slate-700">
      <CardContent className="p-3 sm:p-4">
        <p className="text-[10px] sm:text-xs text-slate-500 uppercase">Total Users</p>
        <p className="text-xl sm:text-2xl font-bold text-white">{realUsers.length}</p>
      </CardContent>
    </Card>
    <Card className={`bg-slate-800 border-slate-700 cursor-pointer transition-all hover:border-amber-500/40 ${expandedSection === 'pending' ? 'border-amber-500/50 ring-1 ring-amber-500/20' : ''}`}
      onClick={() => setExpandedSection(expandedSection === 'pending' ? null : 'pending')}
      data-testid="stat-pending-invites">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[10px] sm:text-xs text-slate-500 uppercase">Pending Invites</p>
            <p className="text-xl sm:text-2xl font-bold text-amber-400">{pendingInvites.length}</p>
          </div>
          {pendingInvites.length > 0 && (expandedSection === 'pending' ? <ChevronUp className="h-4 w-4 text-amber-400" /> : <ChevronDown className="h-4 w-4 text-slate-500" />)}
        </div>
      </CardContent>
    </Card>
    <Card className={`bg-slate-800 border-slate-700 cursor-pointer transition-all hover:border-emerald-500/40 ${expandedSection === 'trials' ? 'border-emerald-500/50 ring-1 ring-emerald-500/20' : ''}`}
      onClick={() => setExpandedSection(expandedSection === 'trials' ? null : 'trials')}
      data-testid="stat-active-trials">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[10px] sm:text-xs text-slate-500 uppercase">Active Trials</p>
            <p className="text-xl sm:text-2xl font-bold text-emerald-400">{activeTrialUsers.length}</p>
          </div>
          {activeTrialUsers.length > 0 && (expandedSection === 'trials' ? <ChevronUp className="h-4 w-4 text-emerald-400" /> : <ChevronDown className="h-4 w-4 text-slate-500" />)}
        </div>
      </CardContent>
    </Card>
    <Card className={`bg-slate-800 border-slate-700 cursor-pointer transition-all hover:border-blue-500/40 ${expandedSection === 'subscribed' ? 'border-blue-500/50 ring-1 ring-blue-500/20' : ''}`}
      onClick={() => setExpandedSection(expandedSection === 'subscribed' ? null : 'subscribed')}
      data-testid="stat-subscribed">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[10px] sm:text-xs text-slate-500 uppercase">Subscribed</p>
            <p className="text-xl sm:text-2xl font-bold text-blue-400">{subscribedUsers.length}</p>
          </div>
          {subscribedUsers.length > 0 && (expandedSection === 'subscribed' ? <ChevronUp className="h-4 w-4 text-blue-400" /> : <ChevronDown className="h-4 w-4 text-slate-500" />)}
        </div>
      </CardContent>
    </Card>
  </div>
);
